module.exports = __webpack_public_path__ + "img/bard.9da8d75d.png";